import tc from "common/common/tcHelpers";

angular
  .module("ticketco/common/arena")
  .controller("arenaController", arenaController);

function arenaController(ArenaItemTypesService) {
  var vm = this;

  var localizeItemTypeGroup = function localizeItemTypeGroup(x) {
    if (vm.entityType === "SeasonPassEvent") {
      return (
        window.TC_LABELS.SEATING_ARRANGEMENT_SEASON_PASS_TYPE_GROUP[
          x.toUpperCase()
        ] || x
      );
    }
    return (
      window.TC_LABELS.SEATING_ARRANGEMENT_ITEM_TYPE_GROUP[x.toUpperCase()] || x
    );
  };

  var getDisabledSections = R.pipe(
    R.pluck("sections"),
    R.flatten,
    R.groupBy(R.prop("name")),
    tc.dataStructure.hash.of,
    R.filter(R.all(R.propEq("has_available_tickets", false))),
    R.reduce(function (acc, curVal) {
      return acc.concat(curVal[0].name);
    }, [])
  );

  var removeHiddenItemTypes = R.filter(
    R.pipe(R.propEq("type", "hidden"), R.not)
  );

  var assignItemTypeGroups = function (itemTypes) {
    vm.itemTypeGroups = R.pipe(
      R.groupBy(R.prop("type")),
      tc.dataStructure.Hash.of,
      R.reduce(function (acc, cur) {
        acc.push({
          title: localizeItemTypeGroup(cur[0].type),
          type: cur[0].type,
          itemTypes: cur,
        });
        return acc;
      }, []),
      R.sort(function (a) {
        return a.type === "open" ? -1 : 1;
      })
    )(itemTypes);
    return itemTypes;
  };

  function assignDisabledSections(itemTypes) {
    vm.disabled = getDisabledSections(itemTypes);
    return itemTypes;
  }

  function assignItemTypes(itemTypes) {
    vm.itemTypes = removeHiddenItemTypes(itemTypes);
    return vm.itemTypes;
  }

  vm.itemTypes = [];

  vm.selectSections = function (id) {
    var itemType = R.find(R.propEq("id", id), vm.itemTypes);
    vm.activeItemType = id;
    vm.selected = itemType
      ? R.pipe(
          R.filter(R.pipe(R.propEq("has_available_tickets", true))),
          R.pluck("name")
        )(itemType.sections)
      : [];
    return vm.selected;
  };

  vm.sectionChange = function (name, event) {
    if (vm.disabled.indexOf(name) !== -1) {
      event.preventDefault();
    }
  };

  vm.initialize = function (eventId, promocode) {
    ArenaItemTypesService.get(eventId, promocode)
      .then(assignItemTypes)
      .then(assignDisabledSections)
      .then(assignItemTypeGroups);
  };
}
